import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";
export async function getProductionPlanComparison(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.productionPlanComparison, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}

export async function getSystemVsMMPlanData(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.systemVsMMPlanData, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}
export async function getAdoptionPlanData(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.adoptionPlanData, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}
export async function getPlanChangeReasonTrend(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.planChangeReasonTrend, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}
export async function getPriorityGraphInsight(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.priorityGraphInsight, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
};

export async function getChangeOverTimeDetails(payload) {
    const requestObj = payload;
    try {
        return await authenticatedFetch(URL.changeOverTimeDetails, {
            method: "POST",
            body: JSON.stringify(requestObj)
        });
    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
};

